import {Component, computed, effect, inject, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';

import {WeatherModel} from '../../models/weather-model';
import {Api} from '../../../../api/api';
import {getWeather} from '../../../../api/functions';
import {rxResource} from '@angular/core/rxjs-interop';
import {catchError, from, of} from 'rxjs';
import {WeatherService} from '../../utils/weather-service';
import { environment } from '../../../../environments/environment';
import {LocationStateService} from '../../../../common/services/location-state.service';
import {PvYieldComponent} from '../pv-yield/pv-yield.component';

@Component({
  selector: 'app-weather-tomorrow',
  imports: [PvYieldComponent],
  templateUrl: './weather-tomorrow.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './weather-tomorrow.component.css',
})
export class WeatherTomorrowComponent {
  api = inject(Api);
  service = inject(WeatherService);
  locationStateService = inject(LocationStateService);
  params = computed(() => ({
    location_id: this.locationStateService.currentLocation()?.id ?? '',
    at: 'tomorrow',
  }));
  private readonly SAMPLE = {
    maxTemperature: 20,
    minTemperature: 10,
    weatherCode: 0,
  };
  resource = rxResource({
    params: this.params,
    defaultValue: environment.showDefault ? this.SAMPLE : undefined,
    stream: (loaderParams) => {
      return from(this.api.invoke(getWeather, loaderParams.params)).pipe(
        catchError((error) => {
          console.log('Weather API does not respond.', error);
          // for development purposes, return a default value
          return of({
            maxTemperature: 20,
            minTemperature: 10,
            weatherCode: 0,
          });
        }),
      );
    },
  });
  resourceValue = computed(() => this.resource.value());
  weatherModel: WritableSignal<WeatherModel> = signal<WeatherModel>({});

  constructor() {
    effect(() => {
      const resourceData = this.resourceValue();
      if (resourceData) {
        this.service.extractAndSetWeatherData(this.weatherModel, resourceData);
      }
    });
  }
}
